module.exports = __webpack_public_path__ + "img/Filter(Button).768cda4f.svg";